import axios from '@/plugins/axios'

class RoomService {
  async getRoomList(type) {
    const { data } = await axios.get(`/sum/api/rooms?type=${type}`)
    return data
  }

  async getRoomInfo(roomSeqId) {
    const { data } = await axios.get(`/sum/api/rooms/${roomSeqId}`)
    return data
  }

  async getRoomDetailInfo(roomSeqId) {
    const { data } = await axios.get(`/sum/api/rooms/detail/${roomSeqId}`)
    return data
  }

  async getZoneDescription(zone) {
    const { data } = await axios.get(`/sum/api/rooms/zone/${zone}`)
    return data
  }

  async createRoom(roomData) {
    const formData = new FormData()
    formData.append('name', roomData.roomName)
    formData.append('company', roomData.companyName)
    formData.append('description', roomData.desc)
    if (roomData.roomPhoto) {
      formData.append('image', roomData.roomPhoto)
    }

    const { data } = await axios.post('/sum/api/rooms', formData)
    return data
  }

  async editRoom(roomData) {
    const formData = new FormData()
    formData.append('name', roomData.roomName)
    formData.append('company', roomData.companyName)
    formData.append('description', roomData.desc)
    if (roomData.roomPhoto) {
      formData.append('image', roomData.roomPhoto)
    }

    const { data } = await axios.put(
      `/sum/api/rooms/${roomData.roomSeqId}`,
      formData
    )
    return data
  }

  async deleteRoom(roomSeqId) {
    const { data } = await axios.delete(`/sum/api/rooms/${roomSeqId}`)
    return data
  }

  async exitRoom(roomSeqId) {
    const { data } = await axios.delete(`/sum/api/rooms/leave/${roomSeqId}`)
    return data
  }

  async sendEmailInvite(params) {
    const roomSeqId = params.roomSeqId

    const formData = new FormData()
    if (roomSeqId) {
      formData.append('id', roomSeqId)
      formData.append('type', 'room_invite')
    } else {
      formData.append('type', 'connection')
    }
    formData.append('userIdList', params.userIdList)

    const { data } = await axios.post('/sum/api/email/invite', formData)
    return data
  }

  async cancelEmailInvite(memberSeqId, partnerSeqId) {
    const { data } = await axios.delete(
      `/sum/api/rooms/invite/${memberSeqId}?partnerSeqId=${partnerSeqId}`
    )
    return data
  }

  async rejectInvite(roomSeqId) {
    const { data } = await axios.delete(`/sum/api/rooms/reject/${roomSeqId}`)
    return data
  }

  async roomJoin(roomSeqId) {
    const { data } = await axios.post(`/sum/api/rooms/${roomSeqId}`, null)
    return data
  }

  async kickUserFromRoom(roomSeqId, memberSeqId) {
    const { data } = await axios.put(
      `/sum/api/rooms/${roomSeqId}/member/${memberSeqId}`,
      null
    )
    return data
  }

  async grantRoomMaster(roomSeqId, memberSeqId) {
    const { data } = await axios.put(
      `/sum/api/rooms/${roomSeqId}/admin/${memberSeqId}`,
      null
    )
    return data
  }
}

export default new RoomService()
